import { render, staticRenderFns } from "./Soft-copyright.vue?vue&type=template&id=6d01bca4&scoped=true&"
import script from "./Soft-copyright.vue?vue&type=script&lang=js&"
export * from "./Soft-copyright.vue?vue&type=script&lang=js&"
import style0 from "./Soft-copyright.vue?vue&type=style&index=0&id=6d01bca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d01bca4",
  null
  
)

export default component.exports